export default __webpack_public_path__ + "static/media/background.b170e244.jpeg";